import { render, staticRenderFns } from "./PreviewTask.vue?vue&type=template&id=5237d453"
import script from "./PreviewTask.vue?vue&type=script&lang=js"
export * from "./PreviewTask.vue?vue&type=script&lang=js"
import style0 from "./PreviewTask.vue?vue&type=style&index=0&id=5237d453&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports